import { AlertType as e } from "@jetbrains/ring-ui-built/components/alert/alert";
import t from "@jetbrains/ring-ui-built/components/alert-service/alert-service";
//#region src/services/alert/alert.ts
var n = 4e3, r = (e, r, i, a = n) => t.addAlert(e, r, a, i), i = (n, r, i) => t.addAlert(n, e.ERROR, r, i), a = (t, n, i) => r(t, e.MESSAGE, i, n), o = (t, n, i) => r(t, e.WARNING, i, n), s = (t, n, i) => r(t, e.SUCCESS, i, n), c = (t, n, i) => r(t, e.LOADING, i, n), l = (t, n, i) => r(t, e.INFO, i, n), u = (e) => {
	t.remove(e);
}, d = () => {
	t.showingAlerts = [], t.renderAlerts();
};
//#endregion
export { u as removeAlert, d as removeAllAlerts, i as showError, l as showInfo, c as showLoading, a as showMessage, s as showSuccess, o as showWarning };
